/**
 * Formats a name segment to proper case.
 * Splits on spaces, hyphens, and apostrophes. For each segment, applies
 * proper case only when the segment is entirely uppercase or entirely lowercase
 * so that intentional mixed casing (e.g. "McDonald") is preserved.
 * Uses locale-aware casing for Unicode/accented characters (e.g. "JOSÉ" → "José").
 */
export function toProperCaseName(value: string): string {
  if (!value.trim()) return value

  return value.replace(/[^\s\-']+/g, segment => {
    if (segment === segment.toLocaleUpperCase() || segment === segment.toLocaleLowerCase()) {
      return segment.charAt(0).toLocaleUpperCase() + segment.slice(1).toLocaleLowerCase()
    }
    return segment
  })
}
